import classNames from 'classnames';

type NewListerBadgeProps = React.HTMLAttributes<HTMLDivElement> & {
  spacing?: number;
};

export const NewListerBadge = (props: NewListerBadgeProps) => {
  return (
    <div {...props} className={classNames('new-lister-badge', props.className)}>
      New lister
    </div>
  );
};
